import { IconArrowLeftOutlined } from "@suse-o11y/icons";
import { type Signal, useComputed } from "@suse-o11y/signal";
import React from "react";

import { Link } from "../link";

import type { SmartHistoryQueue } from "./SmartHistoryQueue";

export interface SmartHistoryBackButtonProps {
	queue: Signal<SmartHistoryQueue>;
}

export const SmartHistoryBackButton: React.FC<SmartHistoryBackButtonProps> = ({ queue }) => {
	const prevSmartHistoryUrl = useComputed(
		(monitor) => queue.read(monitor).at((activeIndex) => activeIndex - 1)?.url,
		[queue],
	);

	return (
		<Link
			className="-mx-3 flex h-7 w-7 shrink-0 items-center justify-center aria-disabled:cursor-not-allowed aria-disabled:text-grey-600"
			data-testid="smart-history-back"
			disabled={prevSmartHistoryUrl == null}
			onClick={() => {
				queue.write((current) => current.jumpTo((currentIndex) => currentIndex - 1));
			}}
			to={prevSmartHistoryUrl!}
		>
			<IconArrowLeftOutlined className="text-xs leading-none" />
		</Link>
	);
};
